import { useFeatureEnabled } from 'core/feature-config/api/queries'
import { useGetPolicyConsentStatus } from 'modules/policy/api/queries'
import { POLICY_CONSENT_FEATURE_KEY } from 'modules/policy/constants'
import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { PATH_POLICY } from 'routes/paths'

import LoadingScreen from 'components/LoadingScreen'

interface PolicyConsentGuardProps {
  children: ReactNode
}

export default function PolicyConsentGuard({ children }: PolicyConsentGuardProps) {
  const { data: featureEnabled, isLoading: featureLoading } = useFeatureEnabled(
    POLICY_CONSENT_FEATURE_KEY
  )
  const {
    data: consentStatus,
    isLoading,
    isError,
  } = useGetPolicyConsentStatus(featureEnabled === true)

  if (featureLoading) return <LoadingScreen />
  // Feature flag off (or unresolvable): no consent enforcement.
  if (!featureEnabled) return <>{children}</>

  if (isLoading) return <LoadingScreen />

  // Deliberate product decision (mirrors the mobile app): a failing
  // consent-status API fails OPEN — a temporary outage must not lock users
  // out of the whole app. The gate re-checks on every mount/reload.
  if (isError) {
    console.warn('[PolicyConsentGuard] consent-status check failed, letting user through')
    return <>{children}</>
  }

  if (consentStatus?.requires_consent) return <Navigate to={PATH_POLICY.consent} replace />
  return <>{children}</>
}
